// BattleMenuLayout.js - 战斗主菜单底部横排布局常量

export const BATTLE_MENU_LAYOUT = {
    BAR_HEIGHT: 100,
    MAX_OPTION_SPACING: 88,
    MIN_OPTION_SPACING: 56,
    HORIZONTAL_PADDING: 20,
    FONT_SIZE: '16px',
    HINT: 'A/D选择  空格确认  ESC取消'
};

/**
 * 计算底部横排战斗菜单位置
 * @param {Phaser.Scene} scene
 * @param {number} optionCount
 * @returns {{ startX: number, optionY: number, spacing: number, hintY: number }}
 */
export function getBattleMenuLayout(scene, optionCount) {
    const { width, height } = scene.cameras.main;
    const count = Math.max(optionCount, 1);
    const available = width - BATTLE_MENU_LAYOUT.HORIZONTAL_PADDING * 2;
    const spacing = count > 1
        ? Math.min(
            BATTLE_MENU_LAYOUT.MAX_OPTION_SPACING,
            Math.max(BATTLE_MENU_LAYOUT.MIN_OPTION_SPACING, available / (count - 1))
        )
        : 0;
    const totalWidth = spacing * Math.max(0, count - 1);

    return {
        startX: (width - totalWidth) / 2,
        optionY: height - BATTLE_MENU_LAYOUT.BAR_HEIGHT / 2,
        spacing,
        hintY: height - 14
    };
}
